import React from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import {Play} from "./Inc";
import {Styles} from './Styles';

interface Props {
    play:Play,
    close():void,
}

const First = (props:Props)=> {
    const classes = Styles.base();
    return (
        <div id="confirm" className={classes.dialogRoot}>
            <div style={{textAlign:"left",paddingBottom:"1em",fontSize:"90%"}}>
                {props.play.name}は{props.play.lover}に会いたい。<br/>
                時間になったら起こしてと言われたから。<br/>
            </div>
            <FormControl fullWidth={true}>
                <Button variant="contained" color="primary" onClick={props.close}>{props.play.lover}を探す</Button>
            </FormControl>
        </div>
    );
}

export default First;
